<template>
  <div
    class="w-full flex sm:flex-wrap"
    :class="[`md:${[width]}`, typeQuestion.name === 'check' ? 'items-start' : 'items-end']"
  >
    <template v-if="typeQuestion.name === 'text'">
      <div
        class="py-2 px-0 md:px-6 w-full"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label
          class="font-semibold"
          for=""
        >{{ question[locale] }}</label>
        <input
          class="h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border w-full rounded pl-6 outline-none"
          type="text"
          :name="name"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          v-validate="validations"
          v-model="field"
          :data-vv-as="question[locale]"
          v-block="block"
          v-blockemojis
          @change="changeAnswer"
        >
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-if="typeQuestion.name === 'textarea'">
      <template v-if="inline">
        <div class="flex flex-wrap md:flex-no-wrap">
          <div
            class="py-2 px-0 md:px-6 w-full md:w-3/5"
            :class="[{'form-group--error': errors.first(`${vvScope}.${name}`)},]"
          >
            <label
              class="font-semibold"
              for=""
            >{{question[locale]}}</label>
            <div class="relative">
              <textarea
                class="mt-2 p-4 pb-8 block border-blue-500 text-gray-700 font-semibold border w-full rounded resize-none"
                rows="6"
                cols="50"
                @input="updateTextLeft"
                :name="name"
                :placeholder="placeholder ? placeholder[locale] : ''"
                :data-vv-scope="vvScope"
                v-validate="{...validations, max_words: 500, min_words: 25}"
                v-model="field"
                :data-vv-as="question[locale]"
                v-block="block"
                v-blockemojis
                @paste.prevent
                @change="changeAnswer"
              ></textarea>
              <span
                class="counter-char text-gray-500 select-none text-xs tracking-widest absolute bottom-0 right-0 p-2 font-bold"
                :class="[{'text-blue-500': field.length >= 480}]"
              >{{textLengthLeft}}/500</span>
            </div>
            <ul>
              <li
                v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
                :key="index"
                class="text-sm text-red-500 font-semibold mt-2 is-danger"
              >
                {{ error }}
              </li>
            </ul>
          </div>
          <div class="w-full md:w-2/5 h-full pt-1 md:pt-10">
            <p
              class="text-blue-500 text-xs md:text-sm"
              v-html="indication[locale]"
            ></p>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="py-2 px-0 md:px-6 w-full"
          :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
        >
          <label
            class="font-semibold"
            for=""
          >{{question[locale]}}</label>
          <div class="relative">
            <textarea
              class="mt-2 p-4 pb-8 block border-blue-500 text-gray-700 font-semibold border w-full rounded resize-none"
              rows="3"
              cols="50"
              @input="updateTextLeft"
              :name="name"
              :placeholder="placeholder ? placeholder[locale] : ''"
              :data-vv-scope="vvScope"
              v-validate="{...validations, max_words: 500, min_words: 25}"
              v-model="field"
              :data-vv-as="question[locale]"
              v-block="block"
              v-blockemojis
              @paste.prevent
              @change="changeAnswer"
            ></textarea>
            <span
              class="counter-char text-gray-500 select-none text-xs tracking-widest absolute bottom-0 right-0 p-2 font-bold"
              :class="[{'text-blue-500': field.length >= 480}]"
            >{{textLengthLeft}}/500</span>
          </div>
          <span
            class="text-blue-500 font-semibold text-sm flex h-auto items-center"
            v-if="indication"
          >
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="h-3 w-3 mr-2 fill-current text-blue-500 inline-block"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ indication[locale] }}
          </span>
          <ul>
            <li
              v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
              :key="index"
              class="text-sm text-red-500 font-semibold mt-2 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </template>
    </template>
    <template v-if="typeQuestion.name === 'textarea-random'">
      <template v-if="inline">
        <div class="flex flex-wrap md:flex-no-wrap">
          <div
            class="py-2 px-0 md:px-6 w-full md:w-3/5"
            :class="[{'form-group--error': errors.first(`${vvScope}.${name}`)},]"
          >
          <label
            class="font-semibold"
            for=""
          >{{ $t("question.indication")}}</label>
          <br>
            <label
              class="font-semibold"
              for=""
            >{{question[locale]}}</label>
            <div class="relative">
              <textarea
                class="mt-2 p-4 pb-8 block border-blue-500 text-gray-700 font-semibold border w-full rounded resize-none"
                rows="6"
                cols="50"
                @input="updateTextLeft"
                :name="name"
                :placeholder="placeholder ? placeholder[locale] : ''"
                :data-vv-scope="vvScope"
                v-validate="{...validations, max_words: 300}"
                v-model="field"
                :data-vv-as="question[locale]"
                v-block="block"
                v-blockemojis
                @paste.prevent
                @change="changeAnswer"
              ></textarea>
              <span
                class="counter-char text-gray-500 select-none text-xs tracking-widest absolute bottom-0 right-0 p-2 font-bold"
                :class="[{'text-blue-500': field.length >= 1}]"
              >{{textLengthLeft}}/300</span>
            </div>
            <ul>
              <li
                v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
                :key="index"
                class="text-sm text-red-500 font-semibold mt-2 is-danger"
              >
                {{ error }}
              </li>
            </ul>
          </div>
          <div class="w-full md:w-2/5 h-full pt-1 md:pt-10">
            <p
              class="text-blue-500 text-xs md:text-sm"
              v-html="indication[locale]"
            ></p>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="py-2 px-0 md:px-6 w-full"
          :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
        >
        <label
            class="font-semibold"
            for=""
          >{{ $t("question.indication")}}</label> <br>
          <label
            class="font-semibold"
            for=""

          >{{question[locale]}}</label>
          <div class="relative">
            <textarea
              class="mt-2 p-4 pb-8 block border-blue-500 text-gray-700 font-semibold border w-full rounded resize-none"
              rows="3"
              cols="50"
              @input="updateTextLeft"
              :name="name"
              :placeholder="placeholder ? placeholder[locale] : ''"
              :data-vv-scope="vvScope"
              v-validate="{...validations, max_words: 300}"
              v-model="field"
              :data-vv-as="question[locale]"
              v-block="block"
              v-blockemojis
              @paste.prevent
              @change="changeAnswer"
            ></textarea>
            <span
              class="counter-char text-gray-500 select-none text-xs tracking-widest absolute bottom-0 right-0 p-2 font-bold"
              :class="[{'text-blue-500': field.length >= 1}]"
            >{{textLengthLeft}}/300</span>
          </div>
          <span
            class="text-blue-500 font-semibold text-sm flex h-auto items-center"
            v-if="indication"
          >
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="h-3 w-3 mr-2 fill-current text-blue-500 inline-block"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ indication[locale] }}
          </span>
          <ul>
            <li
              v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
              :key="index"
              class="text-sm text-red-500 font-semibold mt-2 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </template>
    </template>
    <template v-else-if="typeQuestion.name === 'select'">
      <div
        class="py-2 px-0 md:px-6 w-full"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label class="font-semibold">{{ question[locale] }}</label>
        <select
          class="h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border rounded w-full px-4 bg-white  appearance-none focus:outline-none custom-select"
          :name="name"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          v-validate="validations"
          v-model="field"
          :data-vv-as="question[locale]"
          @change="changeAnswer"
        >
          <option
            v-for="(value) in sortData"
            :key="value.id"
            :value="value.id"
          >{{ value.option[locale] }}</option>
        </select>
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'radio'">
      {{ question[locale] }}
      <div
        v-for="(value) in questionOption"
        :key="value.id"
      >
        <input
          type="radio"
          :name="name"
          :id="value.id"
          :value="value.id"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          v-validate="validations"
          v-model="field"
          :data-vv-as="question[locale]"
          @change="changeAnswer"
        > {{value.title}}
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'check'">
      {{ question[locale] }}
      <div
        v-for="(value) in questionOption"
        :key="value.id"
      >
        <input
          type="checkbox"
          :name="name"
          :id="value.id"
          :value="value.id"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          v-validate="validations"
          v-model="field"
          :data-vv-as="question[locale]"
          @change="changeAnswer"
        > {{value.title}}
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'multiple'">
      <div class="py-2 px-0 md:px-6 w-full">
        <label
          class="font-semibold"
          for=""
        >{{question[locale]}}</label>

        <SelectInput
          @add="addMultipleAnswer"
          @remove="removeMultipleAnswer"
          :withimages="true"
          itemkey="id"
          :multiple="true"
          :limit="10"
          imagekey="url"
          :namekey="meta === 'ideal-couple-live' ? 'name' : 'option'"
          :placeholder="placeholder ? placeholder[locale] : ''"
          vvclass="form-group--error"
          :hasLocale="meta === 'ideal-couple-live' || meta === 'Languages'"
          :sorted="meta === 'ideal-couple-live'"
          :locale="locale"
          :vvscope="vvScope"
          :vvname="name[locale]"
          :vvdata="question[locale]"
          :require="validations.required"
          :items="options"
          :setbeginners="meta === 'ideal-couple-live' ? [257] : []"
        />
        <span
          class="text-blue-500 font-semibold text-sm flex h-auto items-center"
          v-if="indication"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="h-3 w-3 mr-2 fill-current text-blue-500 inline-block"
          >
            <path
              d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
              id="Combined-Shape"
            ></path>
          </svg>
          {{ indication[locale] }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectInput from "@/components/SelectInput.vue";

export default {
  props: [
    "question",
    "answer",
    "typeQuestion",
    "questionOption",
    "placeholder",
    "validations",
    "vvScope",
    "name",
    "width",
    "id",
    "meta",
    "indication",
    "block",
    "ordered",
    "inline"
  ],
  components: {
    SelectInput
  },
  data: () => ({
    field: [],
    answerId: [],
    options: [],
    textLengthLeft: 0
  }),
  watch: {
    locale() {
      this.$nextTick(() => {
        this.errors.items.forEach(e => {
          if (e.regenerate) {
            e.msg = e.regenerate();
          }
        });
      });
    }
  },
  name: "Question",
  async created() {
    if (this.meta === "ideal-couple-live") {
      await this.listCountries();

      this.options = this.countries.slice();
    } else {
      this.options = this.questionOption;
    }
  },

  computed: {
    ...mapState("answer", ["answers"]),
    ...mapState("locale", ["locale"]),
    ...mapState("countries", ["countries"]),
    sortData() {
      if (!!this.ordered) {
        return [...this.questionOption].sort((a, b) =>
          a.option[this.locale].localeCompare(b.option[this.locale])
        );
      }

      return this.questionOption;
    }
  },
  methods: {
    ...mapActions("answer", ["saveAnswers"]),
    ...mapActions("countries", ["listCountries"]),
    updateTextLeft(value) {
      this.textLengthLeft = this.field
        .trim()
        .replace(/\s{2,}/g, " ")
        .split(" ").length;
        this.field = this.field.replace(/\.\./g, "");
        this.field = this.field.replace(/\-\-/g, "");
        this.field = this.field.replace(/\_\_/g, "");

        this.field = this.field.replace(/\.\ \./g, "");
        this.field = this.field.replace(/\-\ \-/g, "");
        this.field = this.field.replace(/\_\ \_/g, "");
    },
    async changeAnswerMultiple() {
      this.field.forEach(element => {
        this.answerId.push(element);
      });

      await this.saveAnswers({
        id: this.id,
        value: this.answerId.toString(),
        type: this.typeQuestion.name
      });

      this.answerId = [];
    },
    addMultipleAnswer(value) {
      const specialValues = this.countries
        .filter(country => !country.iso)
        .map(country => country.id);

      if (this.meta === "ideal-couple-live") {
        const {
          name: { [this.locale]: country }
        } = this.countries.find(country => country.id === value);

        if (/world/gi.test(country) || /mundo/gi.test(country)) {
          this.options = [];
        } else if (specialValues.includes(value)) {
          this.options = this.countries
            .slice()
            .filter(
              country =>
                !country.iso &&
                !/world/gi.test(country.name[this.locale]) &&
                !/mundo/gi.test(country.name[this.locale])
            );
        } else {
          this.options = this.countries
            .slice()
            .filter(country => !!country.url);
        }
      }

      this.field.push(value);
      this.changeAnswerMultiple();
    },
    removeMultipleAnswer(value) {
      if (this.meta === "ideal-couple-live") {
        if (this.field.length === 1) {
          this.options = this.countries.slice();
        }
      }
      this.field = this.field.filter(item => item !== value);
      this.changeAnswerMultiple();
    },
    async changeAnswer() {
      await this.saveAnswers({
        id: this.id,
        value: this.field,
        type: this.typeQuestion.name
      });
    }
  }
};
</script>
<style>
select.custom-select {
  background-image: linear-gradient(45deg, transparent 50%, #0669f9 50%),
    linear-gradient(135deg, #0669f9 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  padding-right: 35px;
}
</style>
